import { getLocalJitsiAudioTrack } from '../../../react/features/base/tracks/functions.any';
import { setNoiseSuppressionEnabled } from '../../../react/features/noise-suppression/actions';
import { SCREEN_SHARING_ERROR } from './actionTypes';
import { isNoiseDisabledByID } from './functions';
export function screenSharingError(error) {
    return {
        type: SCREEN_SHARING_ERROR,
        error
    };
}
export function enableNoiseWhenReady(deviceId) {
    return async (dispatch, getState) => {
        const state = getState();
        const isReady = await dispatch(isNSReady());
        if (!isReady) {
            return;
        }
        if (!isNoiseDisabledByID(state, deviceId)) {
            await dispatch(setNoiseSuppressionEnabled(false));
            dispatch(setNoiseSuppressionEnabled(true));
        }
        else {
            dispatch(setNoiseSuppressionEnabled(false));
        }
    };
}
export function isNSReady() {
    return (dispatch, getState) => new Promise(resolve => {
        const state = getState();
        const localAudio = getLocalJitsiAudioTrack(state);
        let isReady = false;
        if (!localAudio) {
            return resolve(isReady);
        }
        const NSInterval = setInterval(() => {
            if (!localAudio._setEffectInProgress) {
                if (!localAudio._streamEffect) {
                    clearInterval(NSInterval);
                    isReady = true;
                    resolve(isReady);
                    return;
                }
                if (localAudio._streamEffect._noiseSuppressorNode?.port) {
                    clearInterval(NSInterval);
                    isReady = true;
                    resolve(isReady);
                }
            }
        }, 100);
        setTimeout(() => {
            if (!isReady) {
                clearInterval(NSInterval);
                resolve(isReady);
            }
        }, 30000); // This timer is needed if NS is not ready at all
    });
}
